import { Model } from '@vuex-orm/core'

export class UserChannel extends Model {
  static entity = 'userChannel'
  static primaryKey = ['user_id', 'channel_id']

  static fields () {
    return {
      user_id: this.attr(null),
      channel_id: this.attr(null)
    }
  }
}

export default UserChannel
